import { SVGProps } from 'react';

const SelectedTabArrow = ({ ...props }: SVGProps<SVGSVGElement>) => {
  return (
    <svg
      xmlns="http://www.w3.org/2000/svg"
      width="21"
      height="28"
      viewBox="0 0 21 28"
      fill="none"
      {...props}
    >
      <path
        d="M19 14.25H19.75V15.75H19V14.25ZM10.077 13.362L10.7452 13.0215V13.0215L10.077 13.362ZM11.388 14.673L11.7285 14.0048H11.7285L11.388 14.673ZM10.5 0V10.2H9V0H10.5ZM14.55 14.25H19V15.75H14.55V14.25ZM10.5 10.2C10.5 11.0525 10.5006 11.6467 10.5384 12.1093C10.5755 12.5632 10.6446 12.824 10.7452 13.0215L9.40873 13.7025C9.18239 13.2582 9.08803 12.7781 9.04336 12.2315C8.99942 11.6936 9 11.0277 9 10.2H10.5ZM14.55 15.75C13.7223 15.75 13.0564 15.7506 12.5185 15.7066C11.9719 15.662 11.4918 15.5676 11.0475 15.3413L11.7285 14.0048C11.926 14.1054 12.1868 14.1745 12.6407 14.2116C13.1033 14.2494 13.6975 14.25 14.55 14.25V15.75ZM10.7452 13.0215C10.9609 13.4448 11.3052 13.7891 11.7285 14.0048L11.0475 15.3413C10.3419 14.9817 9.76825 14.4081 9.40873 13.7025L10.7452 13.0215Z"
        fill="#B5B5B5"
      />
      <path d="M17 12L20 15L17 18" stroke="#B5B5B5" />
    </svg>
  );
};

export default SelectedTabArrow;
